import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    transitionCategory(_, {
      category,
      body,
    }) {
      if (category.requestedChange) {
        const loggedUser = JSON.parse(localStorage.getItem('userData'))
        return axiosIns.post(`categories/${category.id}/changes-transition`, {
          ...body,
          actor: loggedUser.email,
        })
      }
      return axiosIns.post(`categories/${category.id}/transitions`, body)
    },
    transitionItem(_, {
      item,
      body,
    }) {
      if (item.requestedChange) {
        const loggedUser = JSON.parse(localStorage.getItem('userData'))
        return axiosIns.post(`items/${item.id}/changes-transition`, {
          ...body,
          actor: loggedUser.email,
        })
      }
      return axiosIns.post(`items/${item.id}/transitions`, body)
    },
    transitionGroup(_, {
      group,
      body,
    }) {
      if (group.requestedChange) {
        const loggedUser = JSON.parse(localStorage.getItem('userData'))
        return axiosIns.post(`selection-groups/${group.id}/changes-transition`, {
          ...body,
          actor: loggedUser.email,
        })
      }
      return axiosIns.post(`selection-groups/${group.id}/transitions`, body)
    },
    getBusinessPendingApprovals(_, params) {
      return axiosIns.get('/businesses/pending-reviews', {
        params,
      })
    },
    createBusiness(_, payload) {
      return axiosIns.post('/businesses', payload)
    },
    updateBusiness(_, { businessId, data }) {
      return axiosIns.patch(`/businesses/${businessId}`, data)
    },
    getImagePresignedUrl(_, id) {
      return axiosIns.get(`/businesses/${id}/image-presigned-url`)
    },
    confirmBusiness(_, payload) {
      return axiosIns.post('/businesses/confirm-signup', payload)
    },
    forceConfirmBusiness(_, payload) {
      return axiosIns.post('/admins/admin-confirm', payload)
    },
    getBusinessBillingInfo(_, { id }) {
      return axiosIns.get(`businesses/${id}/wallet`)
    },
    createBusinessBillingInfo(_, payload) {
      return axiosIns.post('wallets/users/payout-wallets', payload)
    },
    patchBusinessBillingInfo(_, { payload, id }) {
      return axiosIns.patch(`wallets/users/payout-wallets/${id}`, payload)
    },
    getBusinesses(_, params) {
      return axiosIns.get('/businesses', {
        params,
      })
    },
    getBusinessTypes(_, params) {
      return axiosIns.get('/businesses/business-types/all', {
        params,
      })
    },
    createBusinessType(_, payload) {
      return axiosIns.post('/businesses/business-types', payload)
    },
    updateBusinessType(_, { id, payload }) {
      return axiosIns.patch(`/businesses/business-types/${id}`, payload)
    },
    deleteBusinessType(_, id) {
      return axiosIns.delete(`/businesses/business-types/${id}`)
    },

    getBusinessBranch(_, businessId) {
      return axiosIns.get(`/businesses/${businessId}/branches`)
    },
    createBusinessBranch(_, { businessId, data }) {
      return axiosIns.post(`/businesses/${businessId}/branches`, data)
    },
    updateBusinessBranch(_, { businessId, branchId, data }) {
      return axiosIns.patch(`/businesses/${businessId}/branches/${branchId}`, data)
    },
    getBusinessByEmail(_, { email }) {
      return axiosIns.get(`/businesses/email/${email}`)
    },

    getAllCategories(_, {
      businessId,
      state,
      pendingReview,
    }) {
      return axiosIns.get('categories', {
        params: {
          state,
          businessId,
          pendingReview,
        },
      })
    },

    getBusinessCategories(_, { businessId }) {
      return axiosIns.get(`categories/business-categories/${businessId}`)
    },

    getBusinessSelectionGroups(_, {
      businessId,
      state,
      pendingReview,
    }) {
      return axiosIns.get('selection-groups', {
        params: {
          businessId,
          state,
          pendingReview,
        },
      })
    },
    getBusinessItems(_, {
      businessId,
      categoryId,
      perPage,
      state,
      pendingReview,
    }) {
      return axiosIns.get('items', {
        params: {
          businessId,
          categoryId,
          perPage,
          state,
          pendingReview,
        },
      })
    },
    getTags(_, { params }) {
      return axiosIns.get('/businesses/tags', {
        params,
      })
    },
    createTag(_, payload) {
      return axiosIns.post('/businesses/tags', payload)
    },
    updateTag(_, { id, payload }) {
      return axiosIns.patch(`/businesses/tags/${id}`, payload)
    },
    deleteTag(_, id) {
      return axiosIns.delete(`/businesses/tags/${id}`)
    },
    createNewBusinessTags(_, { businessId, tags }) {
      return axiosIns.post(`/businesses/tags/business-tags/${businessId}`, {
        tags,
      })
    },
    unlinkTagFromBusiness(_, { businessId, tagId }) {
      return axiosIns.delete(`/businesses/tags/business-tags/${businessId}/${tagId}`)
    },
    getBusinessTags(_, { businessId, params }) {
      return axiosIns.get(`/businesses/tags/business-tags/${businessId}`, {
        params,
      })
    },
    getBusinessDetails(_, { businessId }) {
      return axiosIns.get(`/businesses/${businessId}`)
    },
    transitionBusiness(_, { businessId, body }) {
      return axiosIns.post(`/businesses/${businessId}/transitions`, body)
    },
    transitionBusinessBranch(_, {
      businessId,
      branchId,
      body,
    }) {
      return axiosIns.post(`/businesses/${businessId}/branches/${branchId}/transitions`, body)
    },
    getDocumentPresignedUrl(_, { businessId }) {
      return axiosIns.get(`/businesses/${businessId}/document-presigned-url`)
    },
    getAllDocumentTypes(_, { params }) {
      return axiosIns.get('/businesses/document-types', {
        params,
      })
    },
    getDocuments(_, { id }) {
      return axiosIns.get(`/businesses/${id}/documents/all`)
    },
    createDocument(_, { body, businessId, documentTypeId }) {
      return axiosIns.put(`/businesses/${businessId}/documents/${documentTypeId}`, body)
    },
    createDocumentType(_, payload) {
      return axiosIns.post('/businesses/document-types', payload)
    },
    updateDocumentType(_, { payload, documentTypeId }) {
      return axiosIns.patch(`/businesses/document-types/${documentTypeId}`, payload)
    },
    deleteDocumentType(_, documentTypeId) {
      return axiosIns.delete(`/businesses/document-types/${documentTypeId}`)
    },
    getHeros() {
      return axiosIns.get('/heros')
    },
    createHeros(_, payload) {
      return axiosIns.post('/heros', payload)
    },
    getHero(_, screen) {
      return axiosIns.get(`/heros/${screen}`)
    },
    createCategory(_, payload) {
      return axiosIns.post('/categories', payload)
    },
    updateCategory(_, { payload, catId }) {
      return axiosIns.patch(`/categories/${catId}`, payload)
    },
    deleteCategory(_, { payload, catId }) {
      return axiosIns.delete(`/categories/${catId}`, {
        data: payload,
      })
    },
    createItem(_, payload) {
      return axiosIns.post('/items', payload)
    },
    updateItem(_, { itemId, payload }) {
      return axiosIns.patch(`/items/${itemId}`, payload)
    },
    getOneItem(_, itemId) {
      return axiosIns.get(`/items/${itemId}`)
    },
    deleteItem(_, { payload, itemId }) {
      return axiosIns.delete(`/items/${itemId}`, {
        data: payload,
      })
    },
    updateItemAvailability(_, { itemId, branchId }) {
      return axiosIns.patch(`/items/${itemId}/branches/${branchId}/toggle`)
    },
    createModifierGroup(_, payload) {
      return axiosIns.post('/selection-groups', payload)
    },
    updateModifierGroup(_, { groupId, payload }) {
      return axiosIns.patch(`/selection-groups/${groupId}`, payload)
    },
    deleteGroup(_, { payload, groupId }) {
      return axiosIns.delete(`/selection-groups/${groupId}`, {
        data: payload,
      })
    },
    getBusinessWallet(_, businessId) {
      return axiosIns.get(`businesses/${businessId}/wallet`)
    },
    getBusinessWalletTransactions(_, { walletId, params }) {
      return axiosIns.get(`business/wallets/${walletId}/transactions`, {
        params,
      })
    },
    storeBusinessWalletTransaction(_, { businessId, payload }) {
      return axiosIns.post(`business/wallets/transactions/${businessId}`, payload)
    },
    getBusinessAdmins(_, businessId) {
      return axiosIns.get(`/businesses/${businessId}/users`)
    },
    createBusinessPrefix(_, { promoPrefix, businessId }) {
      return axiosIns.post(`/businesses/${businessId}/promo-prefix`, {
        promoPrefix,
      })
    },
  },
}
